import { render, staticRenderFns } from "./UsuarioPerfil.vue?vue&type=template&id=667cd0cb&scoped=true"
import script from "./UsuarioPerfil.vue?vue&type=script&lang=js"
export * from "./UsuarioPerfil.vue?vue&type=script&lang=js"
import style0 from "./UsuarioPerfil.vue?vue&type=style&index=0&id=667cd0cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667cd0cb",
  null
  
)

export default component.exports